export const containsOnly = <T>(array: Array<T>, value: T): boolean =>
  array.length === 1 && array[0] === value;
